// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2e7m1","log":"ModalInventoryLogs_log__3nqjk","date":"ModalInventoryLogs_date__S0ruc","userName":"ModalInventoryLogs_userName__2D0Bq"};